import Slide09 from "../assets/image/10.png";
import Slide10 from "../assets/image/11.png";
import Slide01 from "../assets/image/2.png";
import Slide02 from "../assets/image/3.png";
import Slide04 from "../assets/image/4.png";
import Slide06 from "../assets/image/6.png";
import Slide07 from "../assets/image/7.png";
import Slide03 from "../assets/image/8.png";
import Slide08 from "../assets/image/9.png";

export const slides = [
    {
        name: "",
        image: Slide01,
    },
    {
        name: "",
        image: Slide02,
    },
    {
        name: "",
        image: Slide03,
    },
    {
        name: "",
        image: Slide04,
    },
    {
        name: "",
        image: Slide06,
    },
    {
        name: "",
        image: Slide07,
    },
    {
        name: "",
        image: Slide08,
    },
    {
        name: "",
        image: Slide09,
    },
    {
        name: "",
        image: Slide10,
    },
];
